<template>
  <nav class="app-menu" aria-label="Primary">
    <div class="app-menu__content">
      <router-link :to="homePath" class="app-menu__brand">86 Proof</router-link>

      <button
        class="app-menu__toggle"
        aria-label="Toggle navigation"
        @click="menuOpen = !menuOpen"
      >
        <span class="app-menu__toggle-bar" />
        <span class="app-menu__toggle-bar" />
        <span class="app-menu__toggle-bar" />
      </button>

      <div class="app-menu__links" :class="{ 'app-menu__links--open': menuOpen }">
        <router-link
          v-for="page in navPages"
          :key="page.slug"
          :to="page.path"
          class="app-menu__link"
          :class="{ 'app-menu__link--active': isActivePath(page.path) }"
        >
          {{ page.label }}
        </router-link>

        <button
          v-if="isAuthenticated"
          class="app-menu__link app-menu__link--button"
          @click="handleLogout"
        >
          Logout
        </button>
        <router-link
          v-else
          to="/login"
          class="app-menu__link"
          :class="{ 'app-menu__link--active': route.path === '/login' }"
        >
          Login
        </router-link>
        <a
          :href="contactHref"
          class="app-menu__link"
        >
          Contact
        </a>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { shellPages } from '@/config/pages'
import { useAuth } from '@/composables/useAuth.js'

const route = useRoute()
const router = useRouter()
const { isAuthenticated, clearToken } = useAuth()

const menuOpen = ref(false)
const contactHref = 'mailto:hello@86proof.ai'
const navPages = computed(() => shellPages.filter(p => !['overview', 'login'].includes(p.slug)))
const homePath = computed(() => '/')

function isActivePath(path) {
  if (path === '/') return route.path === '/'
  return route.path === path || route.path.startsWith(`${path}/`)
}

function handleLogout() {
  clearToken()
  router.push('/')
}
</script>
